var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"gh-btt",on:{"click":_vm.backToTop}},[_c('i',{staticClass:"el-icon-arrow-up gh-btt__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }